<template>
    <b-dropdown
        variant="link"
        right
        toggle-class="text-decoration-none"
        no-caret
    >
        <template #button-content>
            <span style="color: black;" class="fas fa-ellipsis-v"></span>
        </template>
        <b-dropdown-item @click="clicked">View Change Log</b-dropdown-item>
    </b-dropdown>
</template>

<script>
export default {
    data() {
        return {};
    },
    mounted() {},
    computed: {},
    methods: {
        clicked() {
            this.$emit("view-change-log", true);
        }
    }
};
</script>
